/** @jsx isolateComponent */

import { isolateComponent } from '@zapier/common-utils';
import { Button } from '@zapier/design-system';

type Props = {
  onClick: () => void;
};

export const BackButton = ({ onClick }: Props) => (
  <Button color="greyAlt" key="close" onClick={onClick}>
    Back
  </Button>
);
